import React from 'react';
import Img from 'gatsby-image';
import SEO from '../components/seo';
import Layout from '../components/layout';
import { Link, graphql } from 'gatsby';
import { css } from '@emotion/core';

export default ({ data }) => {
  const event = data.allEvent.edges[0].node;
  const image = data.allEvent.edges[0].node.image;
  return (
    <Layout>
      <SEO
        title="Programok"
        keywords={[`szelence`, `café`, `vegán`, `vega`, `programok`]}
      />
      <div className="row justify-content-md-center  my-3">
        <div className="col-md-6">
          <h2>{event.name}</h2>
          <h4 className=" mb-2" style={{ color: `#c63f17` }}>
            {event.date}
          </h4>
          <div className="text-center">
            {image && image.childImageSharp && image.childImageSharp.fluid && (
              <Img
                fluid={image.childImageSharp.fluid}
                alt={event.name}
                className="img-fluid rounded"
              />
            )}
          </div>
          <div className="my-4">
            <div>
              <p
                css={{
                  letterSpacing: '0.05rem',
                  lineHeight: '1.5rem',
                }}
                dangerouslySetInnerHTML={{ __html: event.description }}
              />
            </div>
            <div>
              <Link
                to="/programok"
                css={css`
                  text-decoration: none;
                  color: #422e40;
                `}
              >
                Vissza
              </Link>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export const query = graphql`
  query($slug: String!) {
    allEvent(filter: { slug: { eq: $slug } }) {
      edges {
        node {
          id
          image {
            childImageSharp {
              fluid(maxWidth: 1600, quality: 100) {
                ...GatsbyImageSharpFluid_withWebp
              }
            }
          }
          slug
          description
          name
          date
        }
      }
    }
  }
`;
